'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  onClick: _propTypes2.default.func.isRequired
};

var ModalClose = function ModalClose(_ref) {
  var onClick = _ref.onClick;
  return (
    // eslint-disable-next-line jsx-a11y/href-no-hash
    _react2.default.createElement(
      'a',
      { href: '#', onClick: onClick, className: 'ReactModal__Close icon-replace' },
      _react2.default.createElement('i', { className: 'icon-close-sign' }),
      ' ',
      _react2.default.createElement(
        'span',
        null,
        'Close'
      )
    )
  );
};

ModalClose.displayName = 'ModalClose';
ModalClose.propTypes = propTypes;

exports.default = ModalClose;